import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
export interface Organizator{
  _id:number,
  caption:string | null

}

export interface State {
  organizers: Organizator[] | null,
  loadStatus: boolean
}

const defaultState: State = {
  organizers: null,
  loadStatus: false
};

const getters = {
  organizers: (state: State):Organizator[] | null => state.organizers,
  loadStatus: (state: State):boolean => state.loadStatus
}

const mutations: MutationTree<State> = {
  setOrganizers(state: State, payload: any[]) {
    state.organizers = payload
  },
  setLoadStatus(state: State, payload: boolean) {
    state.loadStatus = payload
  }
}

const actions: ActionTree<State, RootState> = {
   async loadOrganizersFromServer({commit, state}) {
    if (state.organizers == null) {
      commit('setLoadStatus', true)
      try {
        const {data} = await Vue.axios.get('/v4/organizers')
        commit('setOrganizers', data.data.organizers)
        // this.commit('alerts/setAlert',{
        //   show:true,
        //   messages:['Организаторы загружены']
        // })

      }catch (e) {
        this.commit('alerts/setAlert',{
          show:true,
          color:'red',
          messages:[e.message]
        })
        return Promise.reject();
      }
      commit('setLoadStatus', false)
      return Promise.resolve(1);
    }
  },
  // async loadShowFromServer({commit, state},payload:string) {
  //   if(state.events){
  //     let index =  state.events.findIndex((element)=>{
  //       return element.code === payload
  //     })
  //
  //     if(!state.events[index].show){
  //       commit('setLoadStatus', true)
  //       try {
  //         const {data} = await Vue.axios.get('/event/'+payload+'/shows')
  //         commit('setShowsFromEvent', {data,index})
  //         this.commit('alerts/setAlert',{
  //           show:true,
  //           color:'green',
  //           messages:['Выставки  загружены','Данные обновлены']
  //         })
  //       }catch (e) {
  //         console.log(e.message)
  //       }
  //       commit('setLoadStatus', false)
  //     }
  //   }
  // }
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
